// Help text for the "?" icons on the create/edit auction forms (see FieldHint.jsx).
// Edit the wording here; "\n" starts a new line in the tooltip.
const fieldHints = {
  // Auction details
  referenceNumber: "Your own reference for this auction. It is shown on reports.",
  eventType:
    "Forward: bidders compete to pay the most (you are selling).\nReverse: bidders compete to offer the lowest price (you are buying).\nIt cannot be changed after saving.",
  ownerOfLots: "The organisation that owns the lots being auctioned.",
  visibility:
    "Public: anyone can see the auction.\nParticipants only: only bidders added to this auction can see it.\nSeller bidders only: only your own bidders can see it.",
  bidType:
    "Any user: every bid must beat the current lead bid.\nOwn last bid: each bidder only has to beat their own previous bid. Equal bids are allowed; the earlier one ranks higher.\nLocked once bidding starts.",
  testProject: "Choose Yes for a practice auction that is not real business.",
  eventImage: "Picture shown on the auction card for bidders.",
  catalogue: "PDF catalogue that bidders can open from the auction page.",

  // Rules
  previewPeriod:
    "No: bids only once the lot is live.\nYes (Ignore the start price): prebids at any amount.\nYes (Consider the start price): the start price competes with the prebids.\nMandatory: a bidder sees prices and rank only after a first (blind) bid.",
  bidStartDateTime: "When bidding opens.",
  bidEndDateTime: "When bidding closes (before any last-minute extension).",
  overtimePeriod: "How many minutes a lot is extended after an accepted last-minute bid.",
  publishDateTime: "When the auction becomes visible to bidders.",
  extendWithinBidEndMinutes:
    "The \"last minute\" window. An accepted bid placed in these final minutes extends the lot by the overtime period.",
  incrementType: "Whether each lot's step is a fixed amount (Value) or a percentage of the current bid.",
  variableIncrement:
    "Yes: any amount at least one step better.\nNo: only exact steps from the current bid (or the start price when there is no bid).",
  currencySelection: "Lets bidders choose the currency they bid in.",
  showH1L1:
    "Yes: bidders see the lead bid amount.\nNo: bidders see only their own rank, never the lead amount.\nShow top bid rank only: bidders see only whether they are in the top 3.",
  showRankTill: "Bidders ranked up to this number see their rank; lower ranks see no rank. Only applies when Show H1/L1 is Yes.",
  auctionStatus: "Inactive hides the auction from bidders until you set it to Active.",
  eventMessage: "A note shown to bidders on the auction page.",
};

export default fieldHints;
